import * as React from 'react';
import styled from 'styled-components';

interface Props {
  s?: React.CSSProperties;
}

const Svg = styled.svg<Props>`
  width: ${({ s }) => s?.width ?? '100%'};
  height: ${({ s }) => s?.height ?? 'auto'};
`;

const LocationIcon: React.FunctionComponent<Props> = ({ s }: Props) => (
  <Svg s={s} viewBox="0 0 16 16" fill="none">
    <g transform="translate(3, 3)">
      <svg width="10" height="10" viewBox="0 0 16 16">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.307 0a5.271 5.271 0 0 1 3.748 1.596A5.272 5.272 0 0 1 13.18 3.34c.256.65.38 1.346.365 2.045 0 2.923-2.312 3.59-5.239 10.614C5.313 8.98 3 8.298 3 5.375a5.329 5.329 0 0 1 1.537-3.79A5.329 5.329 0 0 1 8.307 0Zm0 3.264a2.05 2.05 0 0 1 1.443.6 2.05 2.05 0 0 1 .6 1.443 2.093 2.093 0 0 1-2.043 2.04 2.043 2.043 0 0 1-1.44-.599 2.043 2.043 0 0 1-.6-1.441A2.004 2.004 0 0 1 7.52 3.41a2.004 2.004 0 0 1 .787-.146Z"
          fill="#2C3239"
        />
      </svg>
    </g>
  </Svg>
);

export default LocationIcon;
